import { Button, Form, Input, Row } from 'antd';
import { useAuthService } from '../../services/authService';
import globalNotification from '../../common/hooks/globalNotification';
import { notificationType } from '../../common/constants/notificationType';
import classes from '../../pages/Profile/style.module.scss';
import { iconColor, spacing } from '../../theming';
import classesAuth from '../../common/styles/FormStyles.module.scss';
import getInputRules, { inputType } from '../../utils/getInputRules';

const ResetPasswordForm = ({ form, setLoading, loading, t, onBack }) => {
    const { changePassword } = useAuthService();

    const onFormSubmit = async ({ currentPassword, newPassword }) => {
        try {
            setLoading(prev => ({ ...prev, resetPassword: true }));
            await changePassword({ currentPassword, newPassword });
            globalNotification.open({
                type: notificationType.SUCCESS,
                message: t('profile:resetMessage'),
                description: t('profile:resetDescription'),
                placement: 'top',
            });
            form.resetFields();
            onBack();
        } catch (error) {
            const errorCode = error.response.data?.code;
            globalNotification.open({
                type: notificationType.ERROR,
                message: t(`apiResponses:${errorCode}.message`),
                description: t(`apiResponses:${errorCode}.description`),
                placement: 'top',
            });
        } finally {
            setLoading(prev => ({ ...prev, resetPassword: false }));
        }
    };

    return (
        <Form requiredMark={false} form={form} onFinish={onFormSubmit} style={{ width: 'clamp(300px, 85vw, 464px)' }}>
            <Form.Item
                className={classesAuth['form-item']}
                label={<span className={classesAuth['form-label']}>{t('profile:currentPassword')}</span>}
                name="currentPassword"
                rules={getInputRules(t, inputType.PASSWORD, t('form:errors.required'))}
                labelCol={{ span: 24 }}
                style={{ marginBottom: '18px' }}
            >
                <Input.Password
                    className={classesAuth['input-login']}
                    prefix={
                        <i
                            className="fi-rr-user-lock"
                            style={{
                                color: iconColor.signin,
                                marginLeft: '18px',
                                marginRight: '10px',
                                fontSize: '18px',
                            }}
                        />
                    }
                />
            </Form.Item>
            <Form.Item
                className={classesAuth['form-item']}
                label={<span className={classesAuth['form-label']}>{t('profile:newPassword')}</span>}
                name="newPassword"
                rules={getInputRules(t, inputType.PASSWORD, t('form:errors.required'))}
                labelCol={{ span: 24 }}
                style={{ marginBottom: '18px' }}
            >
                <Input.Password
                    className={classesAuth['input-login']}
                    prefix={
                        <i
                            className="fi-rr-lock"
                            style={{
                                color: iconColor.signin,
                                marginRight: '12px',
                                fontSize: '18px',
                            }}
                        />
                    }
                />
            </Form.Item>
            <Form.Item
                className={classesAuth['form-item']}
                label={<span className={classesAuth['form-label']}>{t('profile:confirmPassword')}</span>}
                name="confirmPassword"
                dependencies={['newPassword']}
                // rules={getInputRules(t, inputType.PASSWORD, t('form:errors.required'))}
                rules={[
                    {
                        required: true,
                        message: t('form:errors.required'),
                    },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!value || getFieldValue('newPassword') === value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(new Error(t('resetPassword:form.errors.confirm-match')));
                        },
                    }),
                ]}
                labelCol={{ span: 24 }}
            >
                <Input.Password
                    className={classesAuth['input-login']}
                    prefix={
                        <i
                            className="fi-rr-lock"
                            style={{
                                color: iconColor.signin,
                                marginRight: '12px',
                                fontSize: '18px',
                            }}
                        />
                    }
                />
            </Form.Item>
            <Row justify="left" align="left">
                <Button
                    loading={loading}
                    htmlType="submit"
                    className={classes.submitForm}
                    type="primary"
                    size="large"
                    style={{ marginTop: spacing[5] }}
                >
                    {t('profile:resetButton')}
                </Button>
            </Row>
        </Form>
    );
};

export default ResetPasswordForm;
